import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

// APP PAGES
import LoginPage from "../pages/app/LoginPage";
import AuthCallbackPage from "../pages/app/AuthCallbackPage";

const ResultPage = lazy(() => import("../pages/result/page"));
const PassportPage = lazy(() => import("../pages/passport/page"));
const DashboardPage = lazy(() => import("../pages/app/DashboardPage"));
const NewTripPage = lazy(() => import("../pages/app/NewTripPage"));
const SelfServicePassportPage = lazy(() => import("../pages/app/SelfServicePassportPage"));
const SharedSelfServicePassportPage = lazy(() => import("../pages/app/SharedSelfServicePassportPage"));
const DiscoverPage = lazy(() => import("../pages/app/DiscoverPage"));
const DiscoveryMapFramePage = lazy(() => import("../pages/app/DiscoveryMapFramePage"));
const FollowAccountFlight = lazy(() => import("../pages/app/FollowAccountFlight"));

const routes: RouteObject[] = [
  { path: '/flights/follow/:token', element: <FollowAccountFlight /> },
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/resultado",
    element: <ResultPage />,
  },
  {
    path: "/passport/:public_token",
    element: <PassportPage />,
  },
  {
    path: "/passport/shared/:shared_token",
    element: <PassportPage />,
  },

  {
    path: "/app/login",
    element: <LoginPage />,
  },
  {
    path: "/app/auth/callback",
    element: <AuthCallbackPage />,
  },
  {
    path: "/app/dashboard",
    element: <DashboardPage surface="customer" />,
  },
  {
    path: "/app/travel-desk",
    element: <DashboardPage surface="operations" />,
  },

  // por enquanto usa a Home como tela de nova viagem
  {
    path: "/app/new-trip",
    element: <NewTripPage />,
  },
  {
    path: "/app/passport/shared/:shared_token",
    element: <SharedSelfServicePassportPage />,
  },
  {
    path: "/app/passport/:public_token",
    element: <SelfServicePassportPage />,
  },
  {
    path: "/app/discover",
    element: <DiscoverPage />,
  },
  {
    path: "/app/discovery-map-frame",
    element: <DiscoveryMapFramePage />,
  },

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
